import { i18n } from '@boot/i18n.js';
import { editPhaseInfoMessage } from './getMessages.js';

// Default editable phase duration in days
const DEFAULT_EDITABLE_PHASE_DURATION_DAYS = 5;

/**
 * Determine whether this phase is in Progress.
 * @param {String} phase_end - The end date of the phase.
 * @return {Boolean}
 */
function isPhaseInProgress(phase_end) {
    return phase_end === null || phase_end === undefined;
}
/**
 * Checks if the phase is within the editable period. Default to true if phase end is not defined.
 * @param {String} phase_end - The end date of the phase.
 * @return {Boolean} - True if the phase is within the editable period, false otherwise.
 */
function isPhaseEditable(phase_end) {
    if (isPhaseInProgress(phase_end)) {
        return true;
    }
    // Calculate the difference in days between the phase end and the current date
    const phaseEndDateTime = new Date(phase_end);
    const now = new Date();
    const diffDays = Math.abs(
        Math.ceil((phaseEndDateTime - now) / (1000 * 60 * 60 * 24))
    );
    // Check if the phase end is within an editable period
    const editablePeriod = parseInt(
        process.env.EDITABLE_PHASE_DURATION_DAYS ||
            DEFAULT_EDITABLE_PHASE_DURATION_DAYS
    );
    return diffDays < editablePeriod;
}
/**
 * Show phase is uneditable error message
 * @param {String} phase_end - The end date of the phase.
 * @return {String|null} - Uneditable message. Null if no error.
 */
function getUneditableErrorMessage(phase_end) {
    if (isPhaseInProgress(phase_end)) {
        return i18n.global.t(editPhaseInfoMessage);
    } else if (!isPhaseEditable(phase_end)) {
        return i18n.global.t(
            "Phases that have finished more than {editablePeriod} days ago can't be edited.",
            {
                editablePeriod: parseInt(
                    process.env.EDITABLE_PHASE_DURATION_DAYS ||
                        DEFAULT_EDITABLE_PHASE_DURATION_DAYS
                )
            }
        );
    }
    return null;
}

export {
    isPhaseInProgress,
    isPhaseEditable,
    getUneditableErrorMessage,
    DEFAULT_EDITABLE_PHASE_DURATION_DAYS
};
